var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-floating-frame",class:{ 'is-center': _vm.positionCenter, 'is-full-width': _vm.isFullWidth },style:({ bottom: _vm.bottom })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }